<div class="contact component content-card">
  <h1 class="card-title">Contact</h1>
  <p style="max-width: 48ch;">
    Use the form below to send me a message, you can also get in touch with me through
    <a href="https://www.linkedin.com/in/lgcavalheiro/" target="_blank">LinkedIn</a> or <a href="https://github.com/lgcavalheiro" target="_blank">Github</a>.
  </p>
  <form class="contact-form" [formGroup]="contactForm" method="POST" (ngSubmit)="onSubmit()">
    <ul style="list-style: none; padding: 0;">
      <li class="cl-1 text-input">
        <label for="name">Your name</label>
        <input type="text" formControlName="name" name="name" id="name" [ngClass]="applyCssError('name')">
      </li>
      <li class="cl-1 text-input">
        <label for="email">Your email</label>
        <input type="text" formControlName="email" name="_replyto" id="email" [ngClass]="applyCssError('email')">
      </li>
      <li class="cl-1 text-input">
        <label for="subject">Your subject</label>
        <input type="text" formControlName="subject" name="subject" id="subject" [ngClass]="applyCssError('subject')">
      </li>
      <li class="cl-1">
        <label for="message">Your message</label>
        <textarea formControlName="message" name="message" id="message" cols="30" rows="10" [ngClass]="applyCssError('message')"></textarea>
      </li>
      <li>

        <button class="bt-l bt-blue" style="margin-left: 0;" type="submit" [disabled]="isSending">
          Send message
          <i class="fa fa-spinner fa-pulse" *ngIf="isSending"></i>
          <i class="fas fa-check message-ok" *ngIf="messageOk"></i>
        </button>
      </li>
    </ul>
  </form>
</div>
